'use client';

import { motion } from 'framer-motion';
import { EASE_OUT, EASE_CUSTOM } from '@/lib/animations'

interface ScrollRevealProps {
    children?: React.ReactNode;
    delay?: number;
    className?: string;
    y?: number;
}

/**
 * Wraps children in a motion.div that fades + slides up when it enters the viewport.
 * viewport.margin uses CSS rootMargin syntax: "top right bottom left"
 * "0px 0px -80px 0px" = trigger when element is 80px above the bottom edge of the viewport.
 */
export default function ScrollReveal({ children, delay = 0, className = '', y = 40 }: ScrollRevealProps = {}) {
    return (
        <motion.div
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '0px 0px -80px 0px' }}
            transition={{ duration: 0.7, delay, ease: EASE_OUT }}
            className={className}
        >
            {children}
        </motion.div>
    );
}
